import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Shopping = () => {
	const [data, setData] = useState({
		"springMattress": [
			{
				"id": 1,
				"name": "ComfortLux Spring Mattress",
				"type": "Spring",
				"size": "Queen",
				"price": 14999,
				"thickness": "8 inches",
				"features": ["Bonnell Springs", "Breathable Fabric", "Edge Support"],
				"description": "Experience superior bounce and breathability with ComfortLux's premium spring technology.",
				"image": "mattress1.jfif"
			},
			{
				"id": 2,
				"name": "OrthoCare Spring Mattress",
				"type": "Spring",
				"size": "King",
				"price": 17999,
				"thickness": "10 inches",
				"features": ["Pocket Springs", "Anti-Dust", "Orthopedic Support"],
				"description": "Designed for orthopedic comfort, this mattress reduces pressure points and offers enhanced spring support.",
				"image": "mattress2.webp"
			},
			{
				"id": 3,
				"name": "SleepZone Spring Mattress",
				"type": "Spring",
				"size": "Single",
				"price": 9999,
				"thickness": "6 inches",
				"features": ["Dual Comfort", "Bonnell Coil", "Airflow Layer"],
				"description": "Dual-comfort design ensures flexibility and airflow for a restful night.",
				"image": "mattress3.jpg"
			},
			{
				"id": 4,
				"name": "RestWell Spring Mattress",
				"type": "Spring",
				"size": "Double",
				"price": 12999,
				"thickness": "7 inches",
				"features": ["Zoned Support", "Anti-Sagging", "Washable Cover"],
				"description": "A durable, anti-sagging mattress with zoned support for balanced sleep posture.",
				"image": "spring4.jpg"
			},
			{
				"id": 5,
				"name": "DreamSleep Spring Mattress",
				"type": "Spring",
				"size": "Queen",
				"price": 15999,
				"thickness": "9 inches",
				"features": ["Memory Foam Layer", "High Density Springs"],
				"description": "A hybrid mattress combining memory foam comfort and resilient spring support.",
				"image": "mattress4.webp"
			}
		],
		"foamMattress": [
			{
				"id": 6,
				"name": "CloudRest Foam Mattress",
				"type": "Foam",
				"size": "King",
				"price": 13999,
				"thickness": "8 inches",
				"features": ["Pure Foam", "Soft Knitted Cover"],
				"description": "Cloud-like comfort with breathable foam and ultra-soft outer cover.",
				"image": "foam1.jpg"
			},
			{
				"id": 7,
				"name": "OrthoFoam Mattress",
				"type": "Foam",
				"size": "Queen",
				"price": 11999,
				"thickness": "6 inches",
				"features": ["Orthopedic Support", "Anti-Allergic Fabric"],
				"description": "Offers targeted support for back pain relief and a healthy sleeping posture.",
				"image": "mattress5.webp"
			},
			{
				"id": 8,
				"name": "SleepNest Foam Mattress",
				"type": "Foam",
				"size": "Single",
				"price": 7999,
				"thickness": "5 inches",
				"features": ["Firm Support", "High Resilience Foam"],
				"description": "Firm and supportive, this mattress is perfect for individual use or guest rooms.",
				"image": "mattress6.jpg"
			},
			{
				"id": 9,
				"name": "ComfyFoam Mattress",
				"type": "Foam",
				"size": "Double",
				"price": 9999,
				"thickness": "7 inches",
				"features": ["Removable Cover", "Dual Comfort Zones"],
				"description": "Medium-firm feel with easy maintenance and dual-side usability.",
				"image": "foam4.jpg"
			},
			{
				"id": 10,
				"name": "AirFeel Foam Mattress",
				"type": "Foam",
				"size": "Queen",
				"price": 12999,
				"thickness": "8 inches",
				"features": ["Ventilated Design", "Medium Firm"],
				"description": "Airflow-enabled design ensures cooler sleep and long-lasting durability.",
				"image": "foam5.jpg"
			}
		],
		"coirMattress": [
			{
				"id": 11,
				"name": "EcoCoir Natural Mattress",
				"type": "Coir",
				"size": "Queen",
				"price": 10999,
				"thickness": "5 inches",
				"features": ["Natural Coir", "Cotton Cover"],
				"description": "Eco-friendly coir base with breathable cotton top for natural comfort.",
				"image": "mattress7.webp"
			},
			{
				"id": 12,
				"name": "FirmRest Coir Mattress",
				"type": "Coir",
				"size": "King",
				"price": 13999,
				"thickness": "6 inches",
				"features": ["Firm Back Support", "Eco-Friendly"],
				"description": "Extra firm and highly supportive, made for those who prefer a harder surface.",
				"image": "coir2.jpg"
			},
			{
				"id": 13,
				"name": "BackCare Coir Mattress",
				"type": "Coir",
				"size": "Double",
				"price": 9999,
				"thickness": "4 inches",
				"features": ["Breathable Coir Layer", "Antibacterial Fabric"],
				"description": "Natural materials that prevent odor and bacteria with daily use.",
				"image": "coir3.jpg"
			},
			{
				"id": 14,
				"name": "OrthoCoir Mattress",
				"type": "Coir",
				"size": "Single",
				"price": 7499,
				"thickness": "5 inches",
				"features": ["Ortho Layer", "Moisture Resistant"],
				"description": "Moisture-resistant base for long-term orthopedic comfort.",
				"image": "coir4.jpg"
			},
			{
				"id": 15,
				"name": "CoolSleep Coir Mattress",
				"type": "Coir",
				"size": "Queen",
				"price": 11999,
				"thickness": "6 inches",
				"features": ["Ventilated Surface", "Firm Comfort"],
				"description": "Cool and firm sleeping surface, ideal for warm climates.",
				"image": "coir5.jpg"
			}
		],
		"polyfillPillows": [
			{
				"id": 1,
				"name": "SoftCloud Polyfill Pillow",
				"type": "Polyfill",
				"size": "Standard",
				"price": 799,
				"features": ["Soft Touch", "Machine Washable", "Hypoallergenic"],
				"description": "A soft, supportive pillow filled with hypoallergenic polyfill for everyday comfort.",
				"image": "pillow1.jpg"
			},
			{
				"id": 2,
				"name": "SleepEase Polyfill Pillow",
				"type": "Polyfill",
				"size": "Queen",
				"price": 999,
				"features": ["Medium Firmness", "Cotton Cover", "Breathable"],
				"description": "Perfect balance of softness and firmness for a restful sleep.",
				"image": "pillow2.jpg"
			},
			{
				"id": 3,
				"name": "DreamComfort Pillow",
				"type": "Polyfill",
				"size": "King",
				"price": 1199,
				"features": ["Extra Loft", "Anti-Microbial", "No Lump"],
				"description": "Extra lofty design with antimicrobial protection keeps it fresh and durable.",
				"image": "pillow3.jpg"
			},
			{
				"id": 4,
				"name": "OrthoRelief Polyfill Pillow",
				"type": "Polyfill",
				"size": "Standard",
				"price": 899,
				"features": ["Neck Support", "Pressure Relief", "Ultra Soft"],
				"description": "Provides excellent neck alignment for better orthopedic support.",
				"image": "pillow4.jpg"
			},
			{
				"id": 5,
				"name": "CoolNap Polyfill Pillow",
				"type": "Polyfill",
				"size": "Queen",
				"price": 1099,
				"features": ["Cooling Gel Layer", "Sweat Absorbent", "Soft Fiber Fill"],
				"description": "Stay cool and dry all night with our gel-infused cooling polyfill pillow.",
				"image": "pillow5.jpg"
			}
		]
	});

	const allProducts = [
		...data.springMattress,
		...data.foamMattress,
		...data.coirMattress,
		...data.polyfillPillows,
	];

	return (
		<>
			{/* <!-- Start Hero Section --> */}
			<div className="hero">
				<div className="container">
					<div className="row justify-content-between">
						<div className="col-lg-7">
							<div className="intro-excerpt" style={{ width: "100%" }}>
								<h1>Mattress & Pillows</h1>
								<p className="">We are all about making your search for the perfect bed mattress easy. Whether you need orthopedic support, luxurious comfort, CoolTec cooling or more - we have got you covered.</p>
								<p className="">We make finding your perfect pillow effortless. Whether you are looking for that cloud-like softness or that perfect orthopedic contouring support, we have it all for you.</p>
							</div>
						</div>

						<div className="col-lg-5">
							<div style={{ height: "270px", width: "100%" }}>
								<img
									src="images/coir3.jpg"
									alt="Slide 2"
									style={{ height: "270px", width: "100%", objectFit: "cover" }}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <!-- End Hero Section --> */}

			<div className="shopping-container">
				<h2 className="section-title" style={{ fontFamily: "postmans-serif" }}>Explore Our Products</h2>
				<div className="product-grid">
					{allProducts.map((item) => (
						<div key={item.id + item.name} className="product-card">
							<img
								src={`/images/${item.image}`}
								alt={item.name}
								className="product-image"
							/>
							<div className="product-details">
								<h3 className="product-name">{item.name}</h3>
								<p className="product-description">{item.description}</p>
								<p className="product-price">₹{item.price}</p>
								<ul className="product-features">
									<div className='d-flex align-items-center justify-content-between'>
										<div>
											{item.features.map((feature, idx) => (
												<li key={idx}>{feature}</li>
											))}
										</div>
										<div>
											<li><strong>Type:</strong> {item.type}</li>
											<li><strong>Size:</strong> {item.size}</li>
										</div>
									</div>
								</ul>
								<div className="d-flex align-items-center justify-content-between gap-2">
									<a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
										<i className="fa-solid fa-phone"></i> &nbsp; Call Us
									</a>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	)
}

export default Shopping;